enum PlatformBrandingFileKey {
  Logo = "platformLogo",
  LightLogo = "platformLightLogo",
  Favicon = "platformFavicon",
  CardImage = "platformCardImage",
}

export const PLATFORM_BRANDING_FILE_KEYS: PlatformBrandingFileKey[] = [
  PlatformBrandingFileKey.Logo,
  PlatformBrandingFileKey.LightLogo,
  PlatformBrandingFileKey.Favicon,
  PlatformBrandingFileKey.CardImage,
];

export enum PlatformBrandingTextKey {
  PlatformName = "platformName",
  PlatformEmail = "platformEmail",
}

export default PlatformBrandingFileKey;
